import { useCallback, useEffect, useState } from 'react';

import { AutocompleteProps } from '../types';

export interface UseChipsTextFieldResult<Value> {
  value?: AutocompleteProps<Value>['value'];
  onChange: (value: Value[]) => void;
}

export type UseChipsTextFieldParams<Value> = Partial<
  UseChipsTextFieldResult<Value>
>;

const areValuesEqual = <Value>(valueA: Value, valueB: Value): boolean =>
  JSON.stringify(valueA) === JSON.stringify(valueB);

// state for controlled component
export const useChipsTextField = <Value>({
  value,
  onChange: handleChange,
}: UseChipsTextFieldParams<Value>): UseChipsTextFieldResult<Value> => {
  const [chips, setChips] = useState(value);

  const onChange = useCallback(
    (nextValue: Value[]) => {
      setChips(nextValue);

      handleChange?.(nextValue);
    },
    [handleChange],
  );

  useEffect(
    () =>
      setChips(currentValue =>
        areValuesEqual(value, currentValue) ? currentValue : value,
      ),
    [value],
  );

  return { onChange, value: chips };
};
